import Wallpaper from "../../assets/photos/15.jpg";
import WallpaperMobile from "../../assets/photos/13-mobile copy.jpg";
import Facebook from "../../assets/socials/facebook.png";
import YouTube from "../../assets/socials/youtube.png";
import Instagram from "../../assets/socials/instagram.png";
import Photo from "../../assets/photos/1.png";
import Photo2 from "../../assets/photos/2.png";
import Class from "../../assets/photos/20.png";
import Lib from "../../assets/photos/22.png";
import Goose from "../../assets/photos/24.png";
import Online from "../../assets/photos/23.png";
import Prices from "../../assets/photos/7.png";
import "../../styles/circle.css";
import { useAppContext } from "../../context/AppContext";
import { ButtonsTrans, HeaderTrans, OnlineClubTrans, ToasterTrans } from "../../utils/translations";
import '../../styles/circle.css';
import { trackPixelEvent } from "../../utils/pixel";
import ReviewsSection from "../reviews";
import ContactForm from "../ContactForm";
import SetmoreBooking from "../SetmoreBooking";
import { useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Logo from "../../assets/logo.png";
import LoginButton from "../LoginButton";
import LanguageToggler from "../LanguageToggler";
import BeginnerImage from "../../assets/photos/18.jpg";
import ProImage from "../../assets/photos/13-copy.jpg";
import ProImageMobile from "../../assets/photos/19.jpg";
import PricesPhoto from "../../assets/photos/25.jpg";
import PricesPhotoMobile from "../../assets/photos/25.jpg";
import { useAuth0 } from '@auth0/auth0-react';
import CountryToggler from "../CountryToggler";

export default function OnlineClubPage() {
  const { user, language, setToaster, isMobile, onlineClubContent, premiumRoles, country } = useAppContext();
  const learnMoreRef = useRef(null);
  const aboutPracticeRef = useRef(null);
  const classesRef = useRef(null);
  const reviewsRef = useRef(null);
  const contactsRef = useRef(null);
  const whomForRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { loginWithRedirect } = useAuth0();

  const scrollToSection = (ref) => {
    ref?.current?.scrollIntoView({ behavior: "smooth" });
  };

  const isIOS = () => {
    if (typeof navigator !== "undefined") {
      return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    }
    return false;
  };

  const isIosDevice = isIOS();

  const location = useLocation();
  const currentPath = location.pathname;

  const handleSubscribe = () => {
    if (!user) {
      window.localStorage.setItem("redirectTo", "/subscribe");
      loginWithRedirect({ui_locales: navigator.language || "ru"});
    }
    if (premiumRoles.includes(user?.role)) {
      setToaster({
        message: ToasterTrans[language].alreadySubscribed,
        type: "success",
        show: true,
      })
    } else {
      window.location.assign("/subscribe");
    }
  };

  return (
    <main className="flex min-h-screen flex-col items-center justify-between scroll-smooth ">
      {/* Header */}
      <div className={`sticky shadow-md hidden lg:flex justify-between align-middle items-center px-20 w-screen z-50 text-sm font-medium top-0 bg-white h-10 border-b-[1px] ${(currentPath === "/constructor" || currentPath === "/shop" || currentPath === "/about") && "border-brown"}
`}>
        <a
          href="/landing"
          className="flex items-center gap-2 hover:pointer"
        >
          <img alt="logo" src={Logo} className="w-10 pb-1" />
          <span className="text-pink">
            {HeaderTrans[language].onceUp}{" "}
            <span className="text-black">
              {HeaderTrans[language].onMat}
            </span>
          </span>
        </a>
        <div className="flex justify-between gap-5">
          <span onClick={() => { trackPixelEvent("NavigateToSeePracticeLandingPage"); scrollToSection(aboutPracticeRef); }} className="hover:text-pink cursor-pointer">{HeaderTrans[language].aboutClub}</span>
          <span onClick={() => { trackPixelEvent("NavigateToPricesLandingPage"); scrollToSection(classesRef); }} className="hover:text-pink cursor-pointer">{HeaderTrans[language].whatsIncluded}</span>
          <span onClick={() => { trackPixelEvent("NavigateToPricesLandingPage"); scrollToSection(whomForRef); }} className="hover:text-pink cursor-pointer">{HeaderTrans[language].whomFor}</span>
          <span onClick={() => { trackPixelEvent("NavigateToReviewsLandingPage"); scrollToSection(reviewsRef); }} className="hover:text-pink cursor-pointer">{HeaderTrans[language].reviews}</span>
          <span onClick={() => { trackPixelEvent("NavigateToPricesLandingPage"); scrollToSection(contactsRef); }} className="hover:text-pink cursor-pointer">{HeaderTrans[language].prices}</span>
          <span onClick={() => { trackPixelEvent("NavigateToContactsLandingPage"); scrollToSection(contactsRef); }} className="hover:text-pink cursor-pointer">{HeaderTrans[language].contacts}</span>
        </div>
        <div className="flex gap-5">
          <LoginButton />
          <LanguageToggler />
          <CountryToggler />
        </div>
      </div>
      {/* Menu */}
      <div className="sticky z-50 lg:hidden align-middle text-sm font-medium top-0 bg-white w-screen pt-1 flex">
        <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-2xl text-black mb-1 pl-4">
          ☰
        </button>
        <a
          href="/landing"
          className="flex items-center w-fit m-auto gap-2 hover:pointer"
        >
          <img alt="logo" src={Logo} className="w-9 pb-1" />
          <span className="text-pink">
            {HeaderTrans[language].onceUp}{" "}
            <span className="text-black">
              {HeaderTrans[language].onMat}
            </span>
          </span>
        </a>
        <div className="flex items-center gap-2 w-fit m-auto">
          <LanguageToggler />
          <LoginButton />
        </div>
      </div>
      {isMenuOpen && (
        <div className="fixed top-9 left-0 w-full bg-white z-40 flex flex-col items-center text-sm text-black shadow-md">
         
          <span onClick={() => { trackPixelEvent("NavigateToSeePracticeLandingPage"); scrollToSection(aboutPracticeRef); setIsMenuOpen(false)}}  className="py-3 hover:text-pink cursor-pointer">{HeaderTrans[language].aboutClub}</span>
          <span onClick={() => { trackPixelEvent("NavigateToPricesLandingPage"); scrollToSection(classesRef); setIsMenuOpen(false)}}  className="py-3 hover:text-pink cursor-pointer">{HeaderTrans[language].whatsIncluded}</span>
          <span onClick={() => { trackPixelEvent("NavigateToPricesLandingPage"); scrollToSection(whomForRef); setIsMenuOpen(false)}}  className="py-3 hover:text-pink cursor-pointer">{HeaderTrans[language].whomFor}</span>
          <span onClick={() => { trackPixelEvent("NavigateToReviewsLandingPage"); scrollToSection(reviewsRef); setIsMenuOpen(false)}}  className="py-3 hover:text-pink cursor-pointer">{HeaderTrans[language].reviews}</span>
          <span onClick={() => { trackPixelEvent("NavigateToPricesLandingPage"); scrollToSection(contactsRef); setIsMenuOpen(false)}}  className="py-3 hover:text-pink cursor-pointer">{HeaderTrans[language].prices}</span>
          <span onClick={() => { trackPixelEvent("NavigateToContactsLandingPage"); scrollToSection(contactsRef); setIsMenuOpen(false)}}  className="py-3 hover:text-pink cursor-pointer">{HeaderTrans[language].contacts}</span>
          <CountryToggler />
        </div>
      )}

      {/* Main screen */}
      <section>
        <div className="lg:grid lg:grid-cols-2 hidden text-left bg-lightBeige">
          <div className="lg:col-span-1 hidden lg:block">
            <div className="circle small absolute top-16 -left-28 z-10 hidden lg:block"></div>
            <div className="text-darkBrown text-6xl absolute z-20 bg-lightBeige rounded top-32 lg:left-20 left-4 pt-5 w-2/5">
              <div className="-ml-2 text-8xl">{OnlineClubTrans[language].onlineClub}</div>
              {OnlineClubTrans[language].once}{" "}
              {OnlineClubTrans[language].uponamat}
              <h2 className="text-black mt-7 ml-24 text-lg pb-8">

                {OnlineClubTrans[language].description}
              </h2>
              <div onClick={() => { trackPixelEvent("NavigateToSeeMoreLandingPage"); scrollToSection(learnMoreRef) }} className="absolute bg-black rounded-3xl text-white text-base p-3 left-60 -bottom-20 z-20 border-lightBeige  border-8 hover:bg-beige hover:pointer">
                {OnlineClubTrans[language].learnMore}
              </div>
            </div>
          </div>
          <div className="col-span-1 relative ">
            <div className="h-screen overflow-hidden">
              <img
                alt="girl standing on a mat"
                src={isMobile ? WallpaperMobile : Wallpaper}
                className=""
              />
            </div>
            <div className="flex gap-3 absolute bottom-3 lg:-left-56">
              <a onClick={() => { trackPixelEvent("NavigateToFacebook") }} target="_blank" href="https://www.facebook.com/theanyajoy"><img
                className="w-8 h-8 hover:pointer"
                alt="facebook"
                src={Facebook}
              /></a>
              <a href="https://www.youtube.com/@once-up-on-a-mat"
                onClick={() => trackPixelEvent("NavigateToYoutube")}
                target="_blank"><img
                  className="w-8 h-8 hover:pointer"
                  alt="YouTube"
                  src={YouTube}
                /></a>
              <a onClick={() => trackPixelEvent("NavigateToInstagram")} href={language === "russian" ? "https://www.instagram.com/joykayoga/" : "https://www.instagram.com/once.up.on.a.mat"} target="_blank">
                <img
                  className="w-8 h-8 hover:pointer"
                  alt="Instagram"
                  src={Instagram}
                />
              </a>
            </div>
          </div>
        </div>

        <div className="lg:hidden relative h-screen w-screen overflow-hidden">
          <img
            alt="girl standing on a mat"
            src={isMobile ? WallpaperMobile : Wallpaper}
            className="block absolute inset-0 h-full w-full object-cover object-bottom top-auto bottom-0 inset-x-0"
          />
          <div className="absolute text-2xl m-auto top-14 inset-0 text-center w-10/12">
            <div className="bg-lightBeige p-1 rounded-lg text-5xl text-brown">{OnlineClubTrans[language].onlineClub}</div>
            <div className="text-brown text-2xl rounded-lg px-2 pb-2 w-fit m-auto bg-lightBeige inline ">
              {OnlineClubTrans[language].once} {OnlineClubTrans[language].uponamat}
            </div>
            <h2 className="text-black rounded-lg mt-7 text-sm  m-auto py-1 px-2 text-center w-fit">
              {OnlineClubTrans[language].description}
            </h2>
            <a href="/library" onClick={() => trackPixelEvent("NavigateToLibrary")} className="absolute bg-black w-fit right-20 text-center rounded-3xl mt-28 text-white text-xs p-2 hover:bg-beige border-beige">
              {ButtonsTrans[language].learnMore}
            </a>
          </div>
          <div className="flex justify-between items-center absolute bottom-1 w-full px-3">
            <div className="flex gap-3">
              <a target="_blank" onClick={() => trackPixelEvent("NavigateToFacebook")} href="https://www.facebook.com/theanyajoy"><img
                className="w-6 h-6 hover:pointer"
                alt="facebook"
                src={Facebook}
              /></a>
              <a href="https://www.youtube.com/@once-up-on-a-mat"
                onClick={() => trackPixelEvent("NavigateToYoutube")}
                target="_blank"><img
                  className="w-6 h-6 hover:pointer"
                  alt="YouTube"
                  src={YouTube}
                /></a>
              <a onClick={() => trackPixelEvent("NavigateToInstagram")} href={language === "russian" ? "https://www.instagram.com/joykayoga/" : "https://www.instagram.com/once.up.on.a.mat"} target="_blank">
                <img
                  className="w-6 h-6 hover:pointer"
                  alt="Instagram"
                  src={Instagram}
                />
              </a>
            </div>
            {/* <a href="/library" className="bg-black rounded-3xl text-white text-xs p-2 z-20 hover:bg-beige">
            {ButtonsTrans[language].exploreMore}
          </a> */}
          </div>
        </div>
      </section>

      {/* About and Club and Practice */}
      <section ref={aboutPracticeRef} className="bg-white py-10 px-6 w-full">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-start">

          {/* Левая часть - Описание клуба */}
          <div className="text-left space-y-4">
            <div>
              <h2 className="text-2xl md:text-4xl font-bold mb-6 items-center gap-3 md:block hidden"><span className="text-5xl">💡</span>{OnlineClubTrans[language].aboutClub}</h2>
              <p className="text-lg leading-relaxed">{OnlineClubTrans[language].aboutClubDescription}</p>
            </div>

            <div>
              <div className="list-disc list-inside space-y-2 text-lg">
                <strong>{OnlineClubTrans[language].value}:</strong> {OnlineClubTrans[language].valueDescription}
              </div>
            </div>
          </div>

          {/* Правая часть - Описание практики */}
          <div className="bg-orange-50 p-8 rounded-2xl shadow-md text-left space-y-6">
            <div className="text-left space-y-4">
              <div>
                <h2 className="text-2xl md:text-2xl font-bold mb-2 flex items-center gap-2"><span className="text-5xl"></span>{OnlineClubTrans[language].whatIsThisPractice}</h2>
                <p className="text-lg leading-relaxed">{OnlineClubTrans[language].practiceDescription}</p>
              </div>

              <div>
                <ul className="list-disc list-inside space-y-2 text-lg">
                  <strong>{OnlineClubTrans[language].duration}:</strong> {OnlineClubTrans[language].notScary}
                  <ul className="list-disc list-inside ml-6 mt-2 space-y-2 text-base">
                    <li>{OnlineClubTrans[language].warmup}</li>
                    <li>{OnlineClubTrans[language].mainBlock}</li>
                    <li>{OnlineClubTrans[language].shavasana}</li>
                  </ul>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Что входит? */}
      <section ref={classesRef} className="bg-beige py-10 px-6 w-full">
        <h2 className="text-2xl md:text-4xl font-semibold  text-center">📦 {OnlineClubTrans[language].formats}</h2>
        <div className="text-lg md:text-lg font-semibold mb-6 text-center">{OnlineClubTrans[language].formatsDescrition}</div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 max-w-6xl mx-auto text-center">
          {onlineClubContent.map((item, idx) => (
            <div
              key={idx}
              className="relative group w-full h-80 [perspective:1000px] mx-auto"
            >
              <div className="relative w-full h-full transition-transform duration-700 [transform-style:preserve-3d] group-hover:[transform:rotateY(180deg)]">

                {/* Front Side */}
                <div className="absolute inset-0 bg-white rounded-xl shadow-md flex flex-col items-center justify-center p-6 [backface-visibility:hidden]">
                  <img src={item.img} alt={item.title} className="rounded-full w-24 h-24 object-cover mb-4" />
                  <h3 className="text-xl md:text-2xl font-semibold mb-2">{item.title}</h3>
                  <p className="text-sm mb-4">{item.description}</p>

                  {/* Subtle mobile-only pointer in top-right */}
                  <div className="absolute bottom-4 right-5 text-xs text-black opacity-80 md:hidden pointer-events-none select-none">
                    ⤷
                  </div>
                </div>

                {/* Back Side */}
                <div className="absolute inset-0 bg-brown text-white rounded-xl shadow-md flex flex-col items-center justify-center p-6 [transform:rotateY(180deg)] [backface-visibility:hidden]">
                  <h3 className="text-xl font-semibold mb-4 text-white">{item.title}</h3>
                  <p className="text-sm text-white">{item.extra}</p>
                  {item.link && language === "russian" ? <a href={item.link} className="border border-darkBrown px-4 py-2 mt-5 rounded-full hover:bg-beige hover:text-black transition text-sm">
                    {item.button}
                  </a> : <button className="border border-darkBrown px-4 py-2 mt-5 rounded-full hover:bg-beige hover:text-black transition text-sm" onClick={() => {
                    setToaster({
                      message: ToasterTrans[language].comingSoon,
                      type: "info",
                      show: true,
                    });
                  }}>{item.button}</button>}
                </div>

              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Для кого подходит */}
      <section
        ref={whomForRef}
        className={`pb-20 pt-10 px-10 md:px-32 relative ${isIosDevice ? 'bg-scroll' : 'bg-fixed'} bg-cover bg-cente w-screen`}
      >
        {/* drop-shadow-[0_2px_4px_rgba(0,0,0,0.6)] */}
        <h2 className="text-2xl md:text-4xl font-semibold mb-6 text-center ">
          👥 {OnlineClubTrans[language].whoItFits}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Новички */}
          <div>
            <h3 className="text-base md:text-xl font-bold mb-2 mx-auto w-full text-center">
              🧘‍♀️ {OnlineClubTrans[language].newbies}
            </h3>
            <div
              className="relative group rounded-2xl overflow-hidden bg-cover bg-center shadow-xl h-96"
              style={{ backgroundImage: `url(${BeginnerImage})` }}
            >
              <div className="absolute inset-0 group-hover:bg-black/60 transition duration-500 ease-in-out"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-white opacity-0 group-hover:opacity-100 transition duration-700 ease-out text-center md:px-10 md:py-0 p-3">
                <div className="text-base md:text-lg">
                  {OnlineClubTrans[language].regardless}
                </div>
              </div>
              <div className="absolute top-4 right-5 text-xs text-white opacity-80 pointer-events-none select-none">
                👆
              </div>
            </div>
          </div>

          {/* Профи */}
          <div>
            <h3 className="text-base md:text-xl font-bold mb-2  text-center">
              🤸 {OnlineClubTrans[language].pros}
            </h3>
            <div
              className="relative group h-96 rounded-2xl overflow-hidden bg-cover bg-center shadow-xl"
              style={{ backgroundImage: `url(${isMobile ? ProImageMobile : ProImage})` }}
            >
              <div className="absolute inset-0 group-hover:bg-black/60 transition duration-500 ease-in-out"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-white opacity-0 group-hover:opacity-100 transition duration-700 ease-out text-center px-10">
                <div className="text-base md:text-lg">
                  {OnlineClubTrans[language].forWhom}
                </div>
              </div>
              <div className="absolute top-4 right-5 text-xs text-white opacity-80 pointer-events-none select-none">
                👆
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Отзывы */}
      <section ref={reviewsRef} className="w-full">
        <ReviewsSection />
      </section>

      {/* Price and contacts */}
      <section ref={contactsRef} className="bg-и py-16 px-6 w-full">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
          <div className="flex flex-col h-full space-y-0">
            {/* Контакты */}
            <div className="text-center md:text-left space-y-4">
              <h2 className="text-2xl md:text-3xl font-bold md:text-left text-center">🪐 {OnlineClubTrans[language].readyToTry}</h2>
              <div className="text-lg">💳 Стоимость участия - 100₪/месяц {country === "RU" && <p>(2220₽)</p>}
              {language === "russian" && <p className="text-xs">Вы будете перенаправлены в клуб сразу после оформления подписки.</p>}
              </div>
              
              {/* Booking Button */}
              {language === "russian" && <div className="w-fit md:m-0 m-auto">
                <button
                // todo разкоментить когда подписка работает!
                  // onClick={() => language === "russian" && handleSubscribe()}
                  onClick={() => setToaster({
                    message: ToasterTrans[language].comingSoon,
                    type: "info",
                    show: true,
                  })}

                  className="hover:bg-pink rounded-3xl text-white text-lg px-5 py-2 border-lightBeige border-8 bg-brown w-full block"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {language === 'russian' ? "Оформить подписку" : "Coming soon ♥"}
                </button>
              </div>}
              <h3 className="text-2xl text-center md:text-left">📞 {OnlineClubTrans[language].contacts}</h3>
              <p className="text-base text-darkBrown/80">
                {OnlineClubTrans[language].yogaStudio}<br />
                {OnlineClubTrans[language].address}
              </p>
              <p className="text-base text-darkBrown/80">
                📲 WhatsApp / Telegram:{" "}
                <a href="https://wa.me/972559116975" target="blank" className="text-pink-600 hover:underline">
                  +972 55 911 69 75
                </a>
              </p>
            </div>
          </div>

          {/* Правая колонка — Контакты + Форма */}
          <div className="flex flex-col justify-around h-full space-y-0">
            {/* Форма */}
            <ContactForm />
          </div>
        </div>
      </section>
    </main>
  );
};
